/*Global*/
import logo from '../assets/Logo/Logo.jpg';
import zabytek from '../assets/Logo/zabytek.jpg';


/*Home*/ 
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';

/*  Gadzaik*/
import gadziak_main from '../assets/Gadziak/gadziak-main.png';

/*Tree*/
import tree1 from '../assets/Tree/tree-1.jpg';
import tree2 from '../assets/Tree/Tree-2.jpg';
import tree3 from '../assets/Tree/Tree-3.jpg';


/*Partners*/
import partner1 from '../assets/Partners/partner-1.png';
import partner2 from '../assets/Partners/partner-2.png';
import partner3 from '../assets/Partners/partner-3.png';
import partner4 from '../assets/Partners/partner-4.webp';
import partner5 from '../assets/Partners/partner-5.png';
import partner6 from '../assets/Partners/partner-6.png';
import partner7 from '../assets/Partners/partner-7.jpg';
import partner8 from '../assets/Partners/partner-8.jpg';
import partner9 from '../assets/Partners/partner-9.jpg';
import partner10 from '../assets/Partners/partner-10.jpg';
import partner11 from '../assets/Partners/partner-11.jpg';
import partner12 from '../assets/Partners/partner-12.jpg';
import partner13 from '../assets/Partners/partner-13.png';
 

/*About */
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import poznajnas from '../assets/About/Poznaj-nas.jpg';

/*News*/
import news1 from '../assets/News/news-1.jpeg';
import news2 from '../assets/News/news-2.jpg';
import news3 from '../assets/News/news-3.jpg';
import news4 from '../assets/News/news-4.jpg';
import news5 from '../assets/News/news-5.jpg';
import news6 from '../assets/News/news-6.jpg';
import news_new from '../assets/News/news_new.jpg';

import invitation1 from '../assets/news1.jpg';
import invitation2 from '../assets/news2.jpg';

/*History*/
import history1 from '../assets/History/History-1.jpg';
import history2 from '../assets/History/History-2.jpg';
import history3 from '../assets/History/History-3.jpg';

import gallery1 from '../assets/History/gallery-1.jpg';
import gallery2 from '../assets/History/gallery-2.jpg';
import gallery3 from '../assets/History/gallery-3.jpg';
import gallery4 from '../assets/History/gallery-4.jpg';
import gallery5 from '../assets/History/gallery-5.jpg';
import gallery6 from '../assets/History/gallery-6.jpg';
import gallery7 from '../assets/History/gallery-7.jpg';
import gallery8 from '../assets/History/gallery-8.jpg';
import gallery9 from '../assets/History/gallery-9.jpg';

/*Legend*/
import legends1 from '../assets/Legend/legends-1.jpg';

/* Museo */
import museo1 from '../assets/Museo/Museo-1.jpg';

import eksponat1 from '../assets/Museo/Eksponat-1.jpg';
import eksponat2 from '../assets/Museo/Eksponat-2.jpg';
import eksponat3 from '../assets/Museo/Eksponat-3.jpg';
import eksponat4 from '../assets/Museo/Eksponat-4.jpg';
import eksponat5 from '../assets/Museo/Eksponat-5.jpg';
import eksponat6 from '../assets/Museo/Eksponat-6.jpg';
import eksponat7 from '../assets/Museo/Eksponat-7.jpg';
import eksponat8 from '../assets/Museo/Eksponat-8.jpg';
import eksponat9 from '../assets/Museo/Eksponat-9.jpg';

/* Training */
import training1 from '../assets/Training/Training-1.jpg';
import training2 from '../assets/Training/Training-2.jpg';

/*Events*/
import event1 from '../assets/Event/Event-1.jpg';
import event2 from '../assets/Event/Event-2.png';

/*Career*/
import faqs from '../assets/Career/faqs.jpg';

/*Gallery Partners*/
import galleryPartners1 from '../assets/Partners/gallery_partners-1.jpg';
import galleryPartners2 from '../assets/Partners/gallery_partners-2.jpg';
import galleryPartners3 from '../assets/Partners/gallery_partners-3.jpg';
import galleryPartners4 from '../assets/Partners/gallery_partners-4.jpg';
import galleryPartners5 from '../assets/Partners/gallery_partners-5.jpg';
import galleryPartners6 from '../assets/Partners/gallery_partners-6.jpg';
import galleryPartners8 from '../assets/Partners/gallery_partners-8.jpg';
import galleryPartners9 from '../assets/Partners/gallery_partners-9.jpg';
import galleryPartners10 from '../assets/Partners/gallery_partners-10.jpg'; 
import galleryPartners11 from '../assets/Partners/gallery_partners-11.jpg';
import galleryPartners12 from '../assets/Partners/gallery_partners-12.jpg';
import galleryPartners13 from '../assets/Partners/gallery_partners-13.jpg';

/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

/*Psychology*/
import calmest_page from '../assets/Psychology/calmest_page.jpg';
import marta_photo from '../assets/Psychology/martaImage.jpg'; 
import interview_1 from '../assets/Psychology/interview-1.jpg';
import interview_2 from '../assets/Psychology/interview-2.jpg';
import interview_3 from '../assets/Psychology/interview-3.jpg';

import gardenTheraphy_1 from '../assets/GardenTheraphy/garden-theraphy-1.jpg';
import gardenTheraphy_2 from '../assets/GardenTheraphy/garden-theraphy-2.jpg';
import gardenTheraphy_3 from '../assets/GardenTheraphy/garden-theraphy-3.jpg';
import gardenTheraphy_4 from '../assets/GardenTheraphy/garden-theraphy-4.jpg';

/*Rada Naukowa*/
import marta from '../assets/RadaNaukowa/People/marta.png';
import marek_kubacki from '../assets/RadaNaukowa/People/marek_kubacki.jpg';
import dorota from '../assets/RadaNaukowa/People/dorota.jpg';
import ressel from '../assets/RadaNaukowa/People/ressel.jpg';
import szymczak from '../assets/RadaNaukowa/People/szymczak.jpg';
import m_kiedrzynski from '../assets/RadaNaukowa/People/m_kiedrzynski.jpg';
import d_sochacki from '../assets/RadaNaukowa/People/d_sochacki.jpg';
import b_krolik from '../assets/RadaNaukowa/People/b_krolik.jpg';
import l_rojewski from '../assets/RadaNaukowa/People/l_rojewski.jpg';
import bozena_matysiak from '../assets/RadaNaukowa/People/bozena_matysiak.jpg';

import teamGallery_image1 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-1.jpg';
import teamGallery_image2 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-2.jpg';
import teamGallery_image3 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-3.jpg';
import teamGallery_image4 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-4.jpg';
import teamGallery_image5 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-5.jpg';
import teamGallery_image6 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-6.jpg';
import teamGallery_image7 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-7.jpg';
import teamGallery_image8 from '../assets/RadaNaukowa/RadaNaukowa-Gallery/team_gallery_image-8.jpg';

/*Therapy Gallery*/
import therapy_1 from '../assets/TherapyGallery/therapy-1.jpg';
import therapy_2 from '../assets/TherapyGallery/therapy-2.jpg';
import therapy_3 from '../assets/TherapyGallery/therapy-3.jpg';

import easter from '../assets/easter.jpg';

import kolej1 from '../assets/Kolej/kolej_photo_1.jpg';
import kolej2 from '../assets/Kolej/kolej_photo_2.jpg';
import kolej3 from '../assets/Kolej/kolej_photo_3.jpg';
import kolej4 from '../assets/Kolej/kolej_photo_4.jpg';
import kolej5 from '../assets/Kolej/kolej_photo_5.jpg';
import kolej6 from '../assets/Kolej/kolej_photo_6.jpg';
import kolej7 from '../assets/Kolej/kolej_photo_7.jpg';
import kolej8 from '../assets/Kolej/kolej_photo_8.jpg';
import kolej9 from '../assets/Kolej/kolej_photo_9.jpg';
import kolej10 from '../assets/Kolej/kolej_photo_10.jpg';
import kolej11 from '../assets/Kolej/kolej_photo_11.jpg';
import kolej12 from '../assets/Kolej/kolej_photo_12.jpg';
import kolej13 from '../assets/Kolej/kolej_photo_13.jpg';
import kolej14 from '../assets/Kolej/kolej_photo_14.jpg';
import kolej15 from '../assets/Kolej/kolej_photo_15.jpg';
import kolej16 from '../assets/Kolej/kolej_photo_16.jpg';
import kolej17 from '../assets/Kolej/kolej_photo_17.jpg';
import kolej18 from '../assets/Kolej/kolej_photo_18.jpg';

const Images = {

    /*Global*/
    logo,
    zabytek,

    /*Home*/
    home1,
    home2,
    home3,
    gadziak_main,

    /*Sponsors*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,
    partner9,
    partner10,
    partner11,
    partner12,
    partner13,

    /*About*/
    about1,
    about2,
    poznajnas,
    tree1,
    tree2,
    tree3,

    /*News*/
    news1,
    news2,
    news3,
    news4,
    news5,
    news6,
    news_new,

    /*Legend*/
    legends1,

    /* Museo */
    museo1,

    eksponat1,
    eksponat2,
    eksponat3,
    eksponat4,
    eksponat5,
    eksponat6,
    eksponat7,
    eksponat8,
    eksponat9,

    /*Events*/
    event1,
    event2,

    /*Career*/
    faqs,

    /*Gallery Partners*/
    galleryPartners1,
    galleryPartners2,
    galleryPartners3,
    galleryPartners4,
    galleryPartners5,
    galleryPartners6,
    galleryPartners8,
    galleryPartners9,
    galleryPartners10,

    /*service*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*history*/
    history1,
    history2,
    history3,

    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,

    /*Training*/
    training1,
    training2,

    /*Psychology*/
    calmest_page,
    interview_1,
    interview_2,
    interview_3,
    marta_photo,

    gardenTheraphy_1,
    gardenTheraphy_2,
    gardenTheraphy_3,
    gardenTheraphy_4,

    /*Rada Naukowa*/
    marta,
    marek_kubacki,
        dorota,
        ressel,
        szymczak,
        m_kiedrzynski,
        d_sochacki,
        b_krolik,
        l_rojewski,
        bozena_matysiak,

    teamGallery_image1,
    teamGallery_image2,
    teamGallery_image3,
    teamGallery_image4,
    teamGallery_image5,
    teamGallery_image6,
    teamGallery_image7,
    teamGallery_image8,

    easter,
    invitation1,
    invitation2,

    kolej1,
    kolej2,
    kolej3,
    kolej4,
    kolej5,
    kolej6,
    kolej7,
    kolej8,
    kolej9,
    kolej10,
    kolej11,
    kolej12,
    kolej13,
    kolej14,
    kolej15,
    kolej16,
    kolej17,
    kolej18,
  
};

export default Images;